import gql from 'graphql-tag'

export const fetchComercialCategory = () => {
	return {
		query: gql`
			{
				comercial_category(order_by: { id: asc }, where: { active: { _eq: true } }) {
					id
					category
				}
			}
		`,
		update(data) {
			return data.comercial_category
		},
	}
}
